import React from 'react';
import PropTypes from 'prop-types';

const SOFTWARE = "SOFTWARE"
const HARDWARE = "HARDWARE"

const AssetInformation = ({title, label, manufacturer, version}) => {
    title = label === SOFTWARE || label ===  HARDWARE ? `${title} ${version}` : title

    return (
        <div>
            <h2 className="sub-title" id="banner-manufacturer">{manufacturer}</h2>
            <h1 id="banner-name">{title}</h1>
        </div>
    )
}

AssetInformation.propTypes = {
    title: PropTypes.string,
    label: PropTypes.string,
    manufacturer: PropTypes.string
}

export default AssetInformation;



// WEBPACK FOOTER //
// ./src/components/AssetInformation/AssetInformation.js